"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyLinkExpired = void 0;
const react_1 = __importDefault(require("react"));
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const theme_1 = require("../utils/theme");
const style = (0, css_manager_1.registerClass)((theme, sc) => `
	.${sc('value')} {
		font-weight: ${theme.font.weights.bold};
	}
	
	.${sc('spaced-top')} {
		margin-top: ${theme.ratios.l * theme.font.baseSize}px;
	}
`);
const sc = (0, css_manager_1.currySC)(style);
const VerifyLinkExpired = ({ t, isModal, proceed, supportEmail, }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("h2", null, t `Token expired`),
    react_1.default.createElement("section", { className: style },
        t `The activation link is expired`,
        react_1.default.createElement("div", { className: sc('spaced-top') },
            t `If you think we're wrong please`,
            ' ',
            react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`)),
        react_1.default.createElement("div", { className: (0, css_manager_1.cns)(theme_1.footer, sc('centered')) },
            react_1.default.createElement(Button_1.Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: proceed })))));
exports.VerifyLinkExpired = VerifyLinkExpired;
//# sourceMappingURL=VerifyLinkExpired.js.map